module.exports = __webpack_public_path__ + "img/last-element-arrow.538e1a5e.svg";